import {
    createColumnDate,
    createColumnInput,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { putField, conditionFormChecker } from "../../../../utils/form";
import { callDepartment } from "../../../account/register/register.section";
import { createField as createFieldAttach } from "../../../../views/account/verify-identity-file/verify-identity-file.section";
import { createFieldRegister1, createFieldRegisterUserInfo } from "../../../../views/account/register/register.section";
import { defineAsyncComponent } from "vue";
import { Divider } from "ant-design-vue";
import moment from "moment";

const Address = defineAsyncComponent(() => import("../../../../components/address/Address"));

export const callUserRequestType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_REQUEST_TYPE", value: searchQuery });

export const callStatus = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_REQUEST_STATUS", value: searchQuery })
        .then((items) => items.filter((item) => !["draft", "reEdit"].includes(item.key)));

export const callRegisterRole = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REGISTER_ROLE", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.request.user.requestCode"),
            dataIndex: "requestCode",
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("model.user.idCard"),
            dataIndex: "idCard",
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.user.fullnameTh"),
            dataIndex: "companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refPersonType?.key == "1" ? record.companyNameTh : `${record.refTitle?.value} ${record.fullNameTh}`,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            sorter: false,
        }),
        createColumnInput({
            title: () => i18n.global.t("model.user.mobile"),
            dataIndex: "mobile",
            align: "center",
        }),
        createColumnDate({
            title: () => i18n.global.t("views.request.user.startDate"),
            dataIndex: "createDate",
            align: "center",
            sorter: false,
            search: {
                type: "Datetime",
                operator: "between",
                getValue: ({ value }) => moment(value[0] + "T00:00:00").format("YYYY-MM-DD[T]HH:mm:ssZ"),
                getValue2: ({ value }) => moment(value[1] + "T23:59:59").format("YYYY-MM-DD[T]HH:mm:ssZ")
            }
        }),
        createColumnDate({
            title: () => i18n.global.t("views.request.user.approveDate"),
            dataIndex: "refStatusHistoryLastApprove.statusDatetime",
            search: {
                type: "Datetime",
                operator: "between",
                getValue: ({ value }) => moment(value[0] + "T00:00:00").format("YYYY-MM-DD[T]HH:mm:ssZ"),
                getValue2: ({ value }) => moment(value[1] + "T23:59:59").format("YYYY-MM-DD[T]HH:mm:ssZ")
            },
            align: "center",
            sorter: false
        }),
        createColumnSelect({
            title: () => i18n.global.t("views.request.user.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callUserRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.user.refRegisterRole"),
            dataIndex: "refRegisterRole.value",
            inputProp: () => ({ list: callRegisterRole, optLabel: "value" }),
            search: { name: "refRegisterRole.id" },
        }),
        createColumnSelect({
            title: () => i18n.global.t("views.request.user.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
        }),
        createColumnSelect({
            title: () => i18n.global.t("views.request.user.refDepartmentType"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
        }),
    ];
    return columns;
};

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data
    const { modelRef } = useForm
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldRegister1({ props, data, key, isLoading }),
            ...createFieldRegisterUserInfo({ props, data, key, isLoading }),
            {
                visible: () => "PEOPLE" != data.registerType && ["1"].includes(modelRef.refRequestType?.key),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <Divider></Divider>,
            },
            {
                visible: ({ field }) =>conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}AddressType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => (
                    <Address
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        dataProp={data}
                        dataKey={`${prefix}addresses.0`}
                        isLoading={isLoading.value}
                    ></Address>
                ),
            },
            {
                visible: ({ field }) =>conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}sameAddressType`,
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <Divider></Divider>,
            },
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}sameAddressType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => (
                    <Address
                        menuContext={menuContext}
                        viewOnly={viewOnly}
                        dataProp={data}
                        dataKey={`${prefix}addresses.1`}
                        isLoading={isLoading.value}
                    ></Address>
                ),
            },
            {
                visible: () => (["2"].includes(data.useForm.modelRef.refPersonType?.key) || "OFFICER" === data.registerType) && ["1"].includes(modelRef.refRequestType?.key),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <Divider></Divider>,
            },
            ...createFieldAttach({ props, data, key }),
        ],
    });
};
